import React, {
  forwardRef,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";
import GenericMappingForm from "../GenericMappingForm";
import { Form } from "antd";
import { uniqBy, isEmpty } from "lodash";

const DeepfenceMappingForm = forwardRef(function DeepfenceMappingForm(
  props,
  ref
) {
  const [mappedHostList] = useState(() => {
    if (props.record) {
      const { hostId, hostName } = props.record;
      const hostIdArr = hostId.split(",");
      const hostNameArr = hostName.split(",");
      return {
        host: hostIdArr.map((id, index) => ({ id, name: hostNameArr[index] })),
      };
    }
    return { host: [] };
  });
  const [form] = Form.useForm();
  const hostRef = useRef({ host: mappedHostList.host });

  const fetchHosts = useCallback(
    (params) => {
      const { promise, cancel } =
        ToolsIntegrationsAPI.getGenericProjectByToolName(
          props.toolName,
          params
        );
      promise.then((response) => {
        const { projects } = response;
        if (mappedHostList["host"].length > 0 && !isEmpty(response.projects)) {
          response.projects = uniqBy(
            [...response.projects, ...mappedHostList["host"]],
            "name"
          );
        }

        hostRef.current["host"] = uniqBy(
          [...projects, ...hostRef.current["host"]],
          "name"
        );
      });
      return { promise, cancel };
    },
    [props.toolName, mappedHostList]
  );

  const getExtraFieldsData = useCallback((config) => {
    const { hostId } = config;
    const data = hostRef.current.host.reduce(
      (acc, cv) => {
        const { id, name } = cv;
        if (hostId.includes(id)) {
          acc.id.push(id);
          acc.name.push(name);
        }
        return acc;
      },
      { id: [], name: [] }
    );
    return {
      hostId: data.id.join(),
      hostName: data.name.join(),
    };
  }, []);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return { hostId: config.hostId.split(",") };
  }, []);

  const projectChangeHandler = useCallback(
    (value, field, selectValue) => {
      const { name } = field;
      const configurations = form.getFieldValue("configurations");
      let updatedConfiguration = [...configurations];
      updatedConfiguration[name] = {
        ...updatedConfiguration[name],
      };
      form.setFieldsValue({ configurations: updatedConfiguration });
    },
    [form]
  );

  const extraFields = useMemo(
    () => [
      {
        name: "hostId",
        colSpan: "10",
        type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
        label: "Host",
        props: {
          api: fetchHosts,
          onChange: projectChangeHandler,
          apiParams: { login_id: props.loginConfigId, type: "host" },
          autoFocus: true,
          mode: "multiple",
        },
        required: true,
      },
    ],
    [fetchHosts, props.loginConfigId, projectChangeHandler]
  );

  return (
    <GenericMappingForm
      form={form}
      ref={ref}
      extraFields={extraFields}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  );
});

export default DeepfenceMappingForm;